import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IconButton, Box, CardMedia } from "@mui/material";
import { ArrowForwardIos, ArrowBackIos } from "@mui/icons-material";
import styles from "./ProductSlider.styles";

function ProductSlider({ images, productLink }) {
  const [currentImage, setCurrentImage] = useState(0);

  const handleNextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const handlePreviousImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <Box sx={styles.container}>
      <Link to={productLink}>
        <CardMedia
          component="img"
          image={images && images[currentImage]}
          alt="Product Image"
          sx={styles.cardMedia}
        />
      </Link>

      <Box sx={styles.arrowBox}>
        <IconButton onClick={handlePreviousImage} sx={styles.iconButton}>
          <ArrowBackIos />
        </IconButton>
        <IconButton onClick={handleNextImage} sx={styles.iconButton}>
          <ArrowForwardIos />
        </IconButton>
      </Box>
    </Box>
  );
}

export default ProductSlider;
